module.exports = __webpack_public_path__ + "img/Apollo11Logo.b54187d0.png";